export const resellersModalSlider = function() {
    const resellersModalContainer = document.querySelector('.jsResellersSlider');
          resellersSlider();

    function resellersSlider() {
        if (!resellersModalContainer) return;
        const resellersSwiper = new Swiper(resellersModalContainer, {
			slidesPerView: 1,
			slidesPerGroup: 1,
	      	slidesPerColumn: 2,
            observer: true,
			watchOverflow: true,
            navigation: {
                nextEl: '.slider-controls__next',
                prevEl: '.slider-controls__prev'
            },
            breakpointsInverse: true,
            breakpoints: {
                768: {
                    allowTouchMove: false,
                    slidesPerView: 3,
                    slidesPerGroup: 3
               }
           },
           on: {
               observerUpdate: function() {
                   this.slideTo(0);
               }
           }
		});
    }
}
